var map = {
	"./danger-theme.png": 4271,
	"./info-theme.png": 86924,
	"./primary-theme.png": 88825,
	"./secondary-theme.png": 28715,
	"./success-theme.png": 46466,
	"./warning-theme.png": 851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9924;